import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer, LabelList, Text,  } from 'recharts';
import "./fundStats.css";
import "../../common/css/component.css";
import { formatCurrency } from '../../common/util/dataFormatterUtils';

const rootStyles = getComputedStyle(document.documentElement);
const colors = [
    rootStyles.getPropertyValue("--chart-color-1").trim(),
    rootStyles.getPropertyValue("--chart-color-2").trim(),
    rootStyles.getPropertyValue("--chart-color-5").trim(),
];

const CustomizedLabel = props => {
    const { x, y, value } = props;
    return (
        <text x={x} y={y} dy={-4} fill={rootStyles.getPropertyValue("--chart-text-color-primary").trim()} fontSize={12} fontWeight="bold" textAnchor="middle">
            {formatCurrency(value)}
        </text>
    );
};

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p><span className="bold-label">Fund Name:</span> {`${payload[0].payload.fundName}`}</p>
          <p><span className="bold-label">Min Investment:</span> {`${formatCurrency(payload[0].payload.minInvestment)}`}</p>
          <p><span className="bold-label">Average Investment:</span> {`${formatCurrency(payload[0].payload.averageInvestment)}`}</p>
          <p><span className="bold-label">Max Investment:</span> {`${formatCurrency(payload[0].payload.maxInvestment)}`}</p>
        </div>
      );
    }
    return null;
  };

  const CustomizedAxisTick = ({ x, y, payload }) => {
    return (
      <Text x={x} y={y} dy={8} textAnchor="middle" fill="#666" fontSize={10}>
        {payload.value}
      </Text>
    );
  };

const FundStats = ({ fundStats }) => {
    return (
        <div className="component-container-no-border">
            <ResponsiveContainer width="100%" height={400}>
                <BarChart data={fundStats} 
                    margin={{
                        top: 20,
                        right: 5,
                        left: 5,  // Increase the left margin
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="fundName" tick={<CustomizedAxisTick />} interval={0} />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend />
                    <Bar dataKey="minInvestment" fill={colors[0]} name="Min" >
                        <LabelList dataKey="minInvestment" position="top" content={<CustomizedLabel />} />
                    </Bar>
                    <Bar dataKey="averageInvestment" fill={colors[1]} name="Average" >
                        <LabelList dataKey="averageInvestment" position="top" content={<CustomizedLabel />} />
                    </Bar>
                    <Bar dataKey="maxInvestment" fill={colors[2]} name="Max" >
                        <LabelList dataKey="maxInvestment" position="top" content={<CustomizedLabel />} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default FundStats;
